import type { StatustextEntry } from '@hgc/core';
import type { StatusLevel } from '@hgc/ui';

/**
 * `MAV_SEVERITY` → 界面的语义等级。
 *
 * 数值写死而不是查枚举表：`MAV_SEVERITY` 是 2009 年定下、至今未变的固定枚举（0..7），
 * 而查表要依赖 `@hgc/mavlink` 的生成物在运行时已加载 —— 万一没加载成功，
 * "严重告警"会静默降级成"没有等级"，这比硬编码这几个数字糟得多。
 *
 * 映射上有一处刻意：4 (WARNING) 给 `caution` 而不是 `warning`。
 * ArduPilot 的绝大多数 PreArm 提示都是 WARNING，如果它们把标题栏变成红色，
 * 真正的 ERROR/CRITICAL 就再也没有视觉冲击力了。
 */
export function severityLevel(severity: number): StatusLevel {
  if (severity <= 2) return 'critical';
  if (severity === 3) return 'warning';
  if (severity === 4) return 'caution';
  if (severity <= 6) return 'info';
  return 'neutral';
}

/** 历史列表最多留这么多条：再多就没人看得完，而每条快照都要复制一遍整个列表 */
export const NOTICE_LIMIT = 8;

/** 状态文本按时间倒序（新的在上）—— 排障时最关心的永远是最后一句 */
export function recentNotices(
  entries: readonly StatustextEntry[],
  limit: number = NOTICE_LIMIT,
): readonly StatustextEntry[] {
  if (entries.length <= limit) return entries;
  return entries.slice(0, limit);
}
